// -- Luenberger Observer -- Control Systems ----------------------------------------

const S = {
  wrapper:      { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1:           { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c0392b', paddingBottom:'8px', marginBottom:'24px', color:'#7B0D0D' },
  h2:           { fontSize:'1.3rem', fontWeight:'700', color:'#c0392b', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c0392b', paddingLeft:'10px' },
  p:            { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox:      { background:'#FEF0F0', border:'2px solid #c0392b', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7B0D0D', marginBottom:'8px' },
  infoBoxItem:  { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c0392b' },
  table:        { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th:           { background:'#c0392b', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE:          { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff5f5' },
  tdO:          { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff' },
  tdL:          { fontWeight:'600', color:'#7B0D0D', whiteSpace:'nowrap', width:'220px' },
  code:         { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap:        { margin:'24px 0', background:'#fffafa', border:'1px solid #f0cece', borderRadius:'8px', padding:'20px' },
  dTitle:       { fontWeight:'700', fontSize:'0.95rem', color:'#7B0D0D', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption:     { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Formula</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// -- Palette --
const RED    = '#c0392b';
const DKRED  = '#7B0D0D';
const BLUE   = '#2E75B6';
const ORANGE = '#e07b00';
const GREEN  = '#27ae60';
const PURPLE = '#8e44ad';
const TEAL   = '#16a085';
const LTRED  = '#fff5f5';
const LTBLU  = '#eaf3ff';
const LTORG  = '#fff7e6';
const LTGRN  = '#f0fef4';
const LTPUR  = '#f5eeff';
const LTTEAL = '#e8faf5';
const BORDER = '#f0cece';

function Defs() {
  return (
    <defs>
      <marker id="aRed"    markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={RED}/></marker>
      <marker id="aBlue"   markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={BLUE}/></marker>
      <marker id="aOrange" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={ORANGE}/></marker>
      <marker id="aGreen"  markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={GREEN}/></marker>
      <marker id="aPurple" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={PURPLE}/></marker>
      <marker id="aTeal"   markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={TEAL}/></marker>
      <marker id="aGray"   markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#888"/></marker>
    </defs>
  );
}

function Blk({ x, y, w, h, fill, stroke, label, sub, fs=12 }) {
  return (
    <g>
      <rect x={x} y={y} width={w} height={h} rx={5} fill={fill} stroke={stroke} strokeWidth="1.5"/>
      <text x={x+w/2} y={y+h/2+(sub?-5:5)} textAnchor="middle" fontSize={fs} fill={stroke} fontWeight="700">{label}</text>
      {sub && <text x={x+w/2} y={y+h/2+11} textAnchor="middle" fontSize="9" fill={stroke} opacity="0.85">{sub}</text>}
    </g>
  );
}

function Arr({ x1, y1, x2, y2, color=RED, marker='aRed', dash=false, lbl='', lx, ly }) {
  return (
    <g>
      <line x1={x1} y1={y1} x2={x2} y2={y2} stroke={color} strokeWidth="1.8"
        strokeDasharray={dash ? '5 3' : 'none'} markerEnd={'url(#' + marker + ')'}/>
      {lbl && (
        <text x={lx || ((x1+x2)/2)} y={ly || ((y1+y2)/2 - 5)}
          textAnchor="middle" fontSize="10" fill={color} fontWeight="600">{lbl}</text>
      )}
    </g>
  );
}

function Card({ x, y, w, h, bg, bc, lines }) {
  return (
    <g>
      <rect x={x} y={y} width={w} height={h} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
      {lines.map((t, i) => (
        <text key={i} x={x+8} y={y+16+i*15}
          fontSize={i===0 ? '11' : '10'} fill={i===0 ? bc : '#444'} fontWeight={i===0 ? '700' : '400'}>{t}</text>
      ))}
    </g>
  );
}

// =================================================================
// Diagram 1 -- Full observer + plant block diagram
// =================================================================
function DiagramBlockDiagram() {
  const W = 900, H = 380;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Luenberger Observer Block Diagram: x_hat_dot = A*x_hat + B*u + L*(y - C*x_hat)</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* ---- ACTUAL PLANT (top row) ---- */}
        <rect x={10} y={8} width={860} height={4} rx={2} fill={BORDER}/>
        <text x={16} y={22} fontSize="10" fill="#999" fontStyle="italic">Physical Plant (hardware)</text>

        {/* u input arrow */}
        <Arr x1={14} y1={68} x2={50} y2={68} color={RED} marker="aRed"/>
        <text x={8} y={63} fontSize="12" fill={RED} fontWeight="700">u</text>
        <circle cx={38} cy={68} r={4} fill={RED}/>

        {/* Plant block */}
        <Blk x={50} y={46} w={130} h={44} fill={LTBLU} stroke={BLUE} label="PLANT" sub="x_dot=Ax+Bu, y=Cx"/>
        <Arr x1={180} y1={68} x2={258} y2={68} color={BLUE} marker="aBlue"/>
        <circle cx={224} cy={68} r={5} fill={BLUE}/>
        <text x={190} y={60} fontSize="11" fill={BLUE} fontWeight="700">x(t)</text>
        <text x={190} y={73} fontSize="9" fill="#888">(true, unknown)</text>

        {/* Sensor C */}
        <Blk x={258} y={46} w={70} h={44} fill={LTGRN} stroke={GREEN} label="C" sub="sensor"/>
        <Arr x1={328} y1={68} x2={430} y2={68} color={GREEN} marker="aGreen"/>
        <text x={372} y={60} fontSize="12" fill={GREEN} fontWeight="700">y(t)</text>
        <text x={368} y={73} fontSize="9" fill="#888">(measured)</text>

        {/* ---- OBSERVER (bottom row) ---- */}
        <rect x={10} y={126} width={860} height={4} rx={2} fill={BORDER}/>
        <text x={16} y={142} fontSize="10" fill="#999" fontStyle="italic">Luenberger Observer (software, runs in parallel)</text>

        {/* u to observer */}
        <line x1={38} y1={68} x2={38} y2={210} stroke={RED} strokeWidth="1.8"/>
        <Arr x1={38} y1={210} x2={50} y2={210} color={RED} marker="aRed"/>

        {/* Observer block */}
        <Blk x={50} y={188} w={160} h={44} fill={LTPUR} stroke={PURPLE} label="OBSERVER MODEL" sub="x_hat_dot=Ax_hat+Bu+L*(y-C*x_hat)" fs={10}/>
        <Arr x1={210} y1={210} x2={290} y2={210} color={PURPLE} marker="aPurple"/>
        <circle cx={256} cy={210} r={5} fill={PURPLE}/>
        <text x={218} y={202} fontSize="11" fill={PURPLE} fontWeight="700">x_hat(t)</text>
        <text x={214} y={215} fontSize="9" fill="#888">(estimated)</text>

        {/* C_hat: apply C to estimate */}
        <Blk x={290} y={188} w={70} h={44} fill={LTGRN} stroke={GREEN} label="C" sub="x estimate"/>
        <Arr x1={360} y1={210} x2={430} y2={210} color={GREEN} marker="aGreen"/>
        <text x={376} y={202} fontSize="11" fill={GREEN} fontWeight="700">y_hat(t)</text>
        <text x={372} y={215} fontSize="9" fill="#888">(predicted)</text>

        {/* Innovation summer */}
        <circle cx={448} cy={140} r={20} fill="#fff" stroke={ORANGE} strokeWidth="2"/>
        <text x={448} y={146} textAnchor="middle" fontSize="17" fill={ORANGE} fontWeight="700">+</text>
        <text x={435} y={128} fontSize="10" fill={ORANGE}>+</text>
        <text x={435} y={154} fontSize="10" fill={ORANGE}>-</text>

        {/* y -> summer */}
        <line x1={430} y1={68} x2={448} y2={68} stroke={GREEN} strokeWidth="1.8"/>
        <Arr x1={448} y1={68} x2={448} y2={120} color={GREEN} marker="aGreen"/>
        {/* y_hat -> summer (from below) */}
        <line x1={430} y1={210} x2={448} y2={210} stroke={GREEN} strokeWidth="1.8"/>
        <Arr x1={448} y1={210} x2={448} y2={160} color={GREEN} marker="aGreen"/>

        {/* Innovation output e = y - y_hat */}
        <Arr x1={468} y1={140} x2={560} y2={140} color={ORANGE} marker="aOrange"/>
        <text x={504} y={132} fontSize="11" fill={ORANGE} fontWeight="700">e = y - y_hat</text>
        <text x={498} y={145} fontSize="9" fill="#888">innovation / output error</text>

        {/* L gain block */}
        <Blk x={560} y={118} w={80} h={44} fill={LTORG} stroke={ORANGE} label="L" sub="observer gain (nxq)"/>

        {/* L*(e) correction back to observer */}
        <Arr x1={640} y1={140} x2={720} y2={140} color={ORANGE} marker="aOrange"/>
        <line x1={720} y1={140} x2={720} y2={210} stroke={ORANGE} strokeWidth="1.8"/>
        <Arr x1={720} y1={210} x2={210} y2={210} color={ORANGE} marker="aOrange"/>
        <text x={682} y={134} fontSize="10" fill={ORANGE} fontWeight="600">L*e (correction)</text>

        {/* x_hat used for state feedback */}
        <line x1={256} y1={210} x2={256} y2={296} stroke={PURPLE} strokeWidth="1.8"/>
        <Blk x={170} y={280} w={110} h={40} fill={LTRED} stroke={RED} label="-K" sub="state feedback"/>
        <Arr x1={256} y1={300} x2={280} y2={300} color={PURPLE} marker="aPurple"/>
        <Arr x1={280} y1={300} x2={170} y2={300} color={RED} marker="aRed"/>
        <text x={214} y={275} fontSize="9" fill={RED}>u = -K*x_hat</text>
        <Arr x1={170} y1={300} x2={38} y2={300} color={RED} marker="aRed"/>
        <line x1={38} y1={300} x2={38} y2={68} stroke={RED} strokeWidth="1.8"/>

        {/* Legend panel */}
        <rect x={748} y={26} width={140} height={330} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={818} y={44} textAnchor="middle" fontSize="12" fill={DKRED} fontWeight="700">Signal Key</text>
        {[
          { y:52,  color:BLUE,   label:'x(t)',     desc:'True state (unknown)' },
          { y:86,  color:PURPLE, label:'x_hat(t)', desc:'Estimated state' },
          { y:120, color:GREEN,  label:'y(t)',      desc:'Measured output' },
          { y:154, color:GREEN,  label:'y_hat(t)',  desc:'Predicted output' },
          { y:188, color:ORANGE, label:'e(t)',      desc:'Innovation error' },
          { y:222, color:ORANGE, label:'L',         desc:'Observer gain matrix' },
          { y:256, color:RED,    label:'u(t)',       desc:'Control input' },
          { y:290, color:RED,    label:'-K',        desc:'State feedback gain' },
        ].map(({ y, color, label, desc }) => (
          <g key={y}>
            <rect x={754} y={y} width={128} height={30} rx={3} fill="#fafafa" stroke={color} strokeWidth="0.8"/>
            <text x={760} y={y+13} fontSize="11" fill={color} fontWeight="700">{label}:</text>
            <text x={760} y={y+26} fontSize="9.5" fill="#444">{desc}</text>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        The Luenberger observer runs a copy of the plant model in software alongside the physical plant. It receives the same input u(t) and computes a predicted output y_hat = C*x_hat. The innovation e = y - y_hat corrects the model through the gain L: x_hat_dot = A*x_hat + B*u + L*(y - C*x_hat). The estimated states x_hat then drive the state feedback controller u = -K*x_hat. The two design problems (K and L) are solved independently by the separation principle.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 2 -- Observer equation anatomy
// =================================================================
function DiagramEquationAnatomy() {
  const W = 900, H = 320;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Observer Equation Anatomy: x_hat_dot = A*x_hat + B*u + L*(y - C*x_hat)</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Big equation display */}
        <rect x={10} y={10} width={880} height={58} rx={5} fill={LTPUR} stroke={PURPLE} strokeWidth="2"/>
        <text x={450} y={44} textAnchor="middle" fontSize="18" fill={PURPLE} fontWeight="700"
          fontFamily="'Courier New',monospace">
          x_hat_dot  =  A * x_hat  +  B * u  +  L * (y  -  C * x_hat)
        </text>

        {/* Annotation arrows pointing to each term */}
        {/* x_hat_dot */}
        <line x1={82}  y1={68} x2={82}  y2={100} stroke={PURPLE} strokeWidth="1.5"/>
        <polygon points="82,100 78,92 86,92" fill={PURPLE}/>
        <rect x={10}   y={104} width={148} height={68} rx={4} fill={LTPUR} stroke={PURPLE} strokeWidth="1"/>
        <text x={84}   y={120} textAnchor="middle" fontSize="11" fill={PURPLE} fontWeight="700">x_hat_dot</text>
        <text x={84}   y={135} textAnchor="middle" fontSize="9.5" fill="#444">Derivative of estimate</text>
        <text x={84}   y={150} textAnchor="middle" fontSize="9.5" fill="#444">How fast x_hat changes</text>
        <text x={84}   y={165} textAnchor="middle" fontSize="9.5" fill={PURPLE}>State: n-vector</text>

        {/* A * x_hat */}
        <line x1={230} y1={68} x2={230} y2={100} stroke={BLUE} strokeWidth="1.5"/>
        <polygon points="230,100 226,92 234,92" fill={BLUE}/>
        <rect x={158}  y={104} width={148} height={68} rx={4} fill={LTBLU} stroke={BLUE} strokeWidth="1"/>
        <text x={232}  y={120} textAnchor="middle" fontSize="11" fill={BLUE} fontWeight="700">A * x_hat</text>
        <text x={232}  y={135} textAnchor="middle" fontSize="9.5" fill="#444">Free dynamics of model</text>
        <text x={232}  y={150} textAnchor="middle" fontSize="9.5" fill="#444">Same A matrix as plant</text>
        <text x={232}  y={165} textAnchor="middle" fontSize="9.5" fill={BLUE}>Open-loop prediction</text>

        {/* B * u */}
        <line x1={388} y1={68} x2={388} y2={100} stroke={RED} strokeWidth="1.5"/>
        <polygon points="388,100 384,92 392,92" fill={RED}/>
        <rect x={316}  y={104} width={148} height={68} rx={4} fill={LTRED} stroke={RED} strokeWidth="1"/>
        <text x={390}  y={120} textAnchor="middle" fontSize="11" fill={RED} fontWeight="700">B * u</text>
        <text x={390}  y={135} textAnchor="middle" fontSize="9.5" fill="#444">Input driving the model</text>
        <text x={390}  y={150} textAnchor="middle" fontSize="9.5" fill="#444">Same input as real plant</text>
        <text x={390}  y={165} textAnchor="middle" fontSize="9.5" fill={RED}>Known -- measured</text>

        {/* L * (y - C*x_hat) */}
        <line x1={620} y1={68} x2={620} y2={100} stroke={ORANGE} strokeWidth="1.5"/>
        <polygon points="620,100 616,92 624,92" fill={ORANGE}/>
        <rect x={474}  y={104} width={292} height={68} rx={4} fill={LTORG} stroke={ORANGE} strokeWidth="1.5"/>
        <text x={620}  y={120} textAnchor="middle" fontSize="11" fill={ORANGE} fontWeight="700">L * (y - C * x_hat)   CORRECTION TERM</text>
        <text x={620}  y={135} textAnchor="middle" fontSize="9.5" fill="#444">Output error injected back into model</text>
        <text x={620}  y={150} textAnchor="middle" fontSize="9.5" fill="#444">L scales the correction; larger L = faster convergence</text>
        <text x={620}  y={165} textAnchor="middle" fontSize="9.5" fill={ORANGE}>This is what makes it an observer, not just a simulator</text>

        {/* Error dynamics derivation */}
        <rect x={10} y={186} width={880} height={122} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={450} y={204} textAnchor="middle" fontSize="13" fill={DKRED} fontWeight="700">Deriving the Error Dynamics</text>

        {[
          { x:20,  color:BLUE,   bg:LTBLU,  lines:['Step 1: define error',    'e_obs = x - x_hat',          'True state minus estimate'] },
          { x:238, color:PURPLE, bg:LTPUR,  lines:['Step 2: differentiate',   'e_dot = x_dot - x_hat_dot',  'Subtract observer from plant eqn'] },
          { x:456, color:ORANGE, bg:LTORG,  lines:['Step 3: substitute',      'e_dot = Ax+Bu - (Ax_hat+Bu+L*(y-Cx_hat))','Expand both equations'] },
          { x:674, color:RED,    bg:LTRED,  lines:['Step 4: simplify',        'e_dot = (A - L*C) * e_obs',  'Error decays if eig(A-LC) in LHP'] },
        ].map(({ x, color, bg, lines }) => (
          <Card key={x} x={x} y={210} w={210} h={90} bg={bg} bc={color} lines={lines}/>
        ))}
      </svg>
      <div style={S.dCaption}>
        The observer equation has three terms: the open-loop model prediction A*x_hat, the known input effect B*u, and the crucial correction term L*(y - C*x_hat). By subtracting the observer equation from the plant equation, the estimation error e = x - x_hat satisfies e_dot = (A - L*C)*e. This is the key result: the error decays to zero if all eigenvalues of (A - L*C) are in the left-half plane, which is achieved by choosing L appropriately.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 3 -- Error convergence: time-domain curves
// =================================================================
function DiagramErrorConvergence() {
  const W = 900, H = 360;
  const bx = 60, by = 30, bw = 520, bh = 280;
  const tMax = 4.0;
  const toX = t => bx + (t / tMax) * bw;
  const toY = v => by + bh/2 - v * (bh * 0.38);

  // Error curves for different observer speeds: e(t) = e0 * exp(sigma_obs * t) * cos(wd*t)
  const curves = [
    {
      label: 'Very slow observer (sigma=0.3)',
      color: RED, sigma: 0.3, wd: 0.8, e0: 1.0,
    },
    {
      label: 'Slow observer (sigma=0.8)',
      color: ORANGE, sigma: 0.8, wd: 1.5, e0: 1.0,
    },
    {
      label: 'Recommended (sigma=4, 2x faster than CL)',
      color: GREEN, sigma: 4.0, wd: 4.0, e0: 1.0,
    },
    {
      label: 'Fast observer (sigma=8)',
      color: BLUE, sigma: 8.0, wd: 6.0, e0: 1.0,
    },
    {
      label: 'Too fast -- noise amplification',
      color: PURPLE, sigma: 16.0, wd: 14.0, e0: 1.0,
    },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Observer Error Convergence e(t) = x(t) - x_hat(t) for Different Observer Speeds</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Plot area */}
        <rect x={bx} y={by} width={bw} height={bh} rx={4} fill="#fff" stroke={BORDER}/>

        {/* Grid -- horizontal */}
        {[-1.0, -0.5, 0, 0.5, 1.0].map(v => (
          <g key={'hg'+v}>
            <line x1={bx} y1={toY(v)} x2={bx+bw} y2={toY(v)} stroke={v===0 ? '#bbb' : '#f5f0f0'} strokeWidth={v===0 ? 1.4 : 1}/>
            <text x={bx-6} y={toY(v)+4} textAnchor="end" fontSize="10" fill="#bbb">{v.toFixed(1)}</text>
          </g>
        ))}
        {[0,1,2,3,4].map(t => (
          <g key={'vg'+t}>
            <line x1={toX(t)} y1={by} x2={toX(t)} y2={by+bh} stroke="#f5f0f0" strokeWidth="1"/>
            <text x={toX(t)} y={by+bh+14} textAnchor="middle" fontSize="10" fill="#bbb">{t}</text>
          </g>
        ))}

        {/* Axes */}
        <line x1={bx} y1={by+bh} x2={bx+bw} y2={by+bh} stroke="#aaa" strokeWidth="1.3"/>
        <line x1={bx} y1={by}    x2={bx}    y2={by+bh} stroke="#aaa" strokeWidth="1.3"/>
        <text x={bx+bw/2} y={by+bh+26} textAnchor="middle" fontSize="11" fill="#777">Time (s)</text>
        <text x={bx-38} y={by+bh/2} textAnchor="middle" fontSize="11" fill="#777"
          transform={'rotate(-90,' + (bx-38) + ',' + (by+bh/2) + ')'}>Error e(t) = x - x_hat</text>

        {/* Curves */}
        {curves.map(({ color, sigma, wd, e0 }) => {
          const pts = Array.from({ length: 100 }, (_, k) => {
            const t = k * tMax / 99;
            const v = e0 * Math.exp(-sigma * t) * Math.cos(wd * t);
            return toX(t) + ',' + toY(v);
          }).join(' ');
          return (
            <polyline key={color + sigma} points={pts} fill="none" stroke={color} strokeWidth="2.2"/>
          );
        })}

        {/* Zero error reference */}
        <line x1={bx} y1={toY(0)} x2={bx+bw} y2={toY(0)} stroke="#bbb" strokeWidth="1.5" strokeDasharray="5 3"/>

        {/* Legend */}
        {curves.map(({ label, color }, i) => (
          <g key={'leg'+i}>
            <line x1={bx+bw-340} y1={by+16+i*30} x2={bx+bw-312} y2={by+16+i*30} stroke={color} strokeWidth="2.5"/>
            <text x={bx+bw-308} y={by+20+i*30} fontSize="10" fill={color} fontWeight="700">{label}</text>
          </g>
        ))}

        {/* Right panel */}
        <rect x={600} y={by} width={286} height={bh} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={743} y={by+16} textAnchor="middle" fontSize="12" fill={DKRED} fontWeight="700">Speed vs Noise Trade-off</text>

        {[
          { y:by+24, bg:LTRED,  bc:RED,    lines:['Slow observer (sigma small)','Error decays slowly','Controller uses poor x_hat','May destabilise fast dynamics'] },
          { y:by+90, bg:LTGRN,  bc:GREEN,  lines:['Recommended (2-5x faster)','sigma_obs >= 2*sigma_cl','Good convergence, low noise','Standard design rule'] },
          { y:by+156, bg:LTBLU, bc:BLUE,   lines:['Fast observer (sigma large)','Error converges quickly','BUT amplifies measurement noise','Larger L = more noise sensitivity'] },
          { y:by+222, bg:LTPUR, bc:PURPLE, lines:['Too fast -- avoid','L has very large entries','Measurement noise dominates x_hat','Use Kalman filter instead'] },
        ].map(({ y, bg, bc, lines }) => (
          <Card key={y} x={606} y={y} w={274} h={62} bg={bg} bc={bc} lines={lines}/>
        ))}
      </svg>
      <div style={S.dCaption}>
        The observer error e(t) = x - x_hat decays like e^(-(A-LC)t) times initial error. Faster observer poles (larger Re(A-LC)) give quicker convergence. However, large L entries amplify measurement noise -- a fundamental trade-off. The recommended design rule places observer poles 2 to 5 times faster than the closed-loop poles. When measurement noise is significant, the Kalman filter (optimal L) should be used instead.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 4 -- s-plane: CL poles vs observer poles
// =================================================================
function DiagramSPlaneDual() {
  const W = 900, H = 380;
  const px = 60, py = 20, pw = 480, ph = 340;
  const xR = [-12, 2], yR = [-5, 5];
  const toX = r => px + (r - xR[0]) / (xR[1] - xR[0]) * pw;
  const toY = i => py + (1 - (i - yR[0]) / (yR[1] - yR[0])) * ph;
  const ox = toX(0);

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>s-Plane: Closed-Loop Poles (K) and Observer Poles (L) -- Separation Principle</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Plot area */}
        <rect x={px} y={py} width={pw} height={ph} rx={4} fill="#fff" stroke={BORDER}/>
        <rect x={ox} y={py} width={px+pw-ox} height={ph} fill="#ffebee" opacity="0.25"/>
        <text x={ox+40} y={py+22} textAnchor="middle" fontSize="11" fill={RED} opacity="0.5" fontWeight="700">UNSTABLE</text>
        <text x={ox-60} y={py+22} textAnchor="middle" fontSize="11" fill={GREEN} opacity="0.5" fontWeight="700">STABLE</text>

        {/* Grid */}
        {[-10,-8,-6,-4,-2,0].map(v => (
          <g key={'gx'+v}>
            <line x1={toX(v)} y1={py} x2={toX(v)} y2={py+ph} stroke="#f5f0f0" strokeWidth="1"/>
            {v !== 0 && <text x={toX(v)} y={py+ph+14} textAnchor="middle" fontSize="9" fill="#ccc">{v}</text>}
          </g>
        ))}
        {[-4,-3,-2,-1,1,2,3,4].map(v => (
          <g key={'gy'+v}>
            <line x1={px} y1={toY(v)} x2={px+pw} y2={toY(v)} stroke="#f5f0f0" strokeWidth="1"/>
            <text x={px-4} y={toY(v)+4} textAnchor="end" fontSize="9" fill="#ccc">{v > 0 ? '+' + v + 'j' : v + 'j'}</text>
          </g>
        ))}

        {/* Axes */}
        <line x1={px} y1={toY(0)} x2={px+pw} y2={toY(0)} stroke="#ccc" strokeWidth="1.4"/>
        <line x1={ox} y1={py}     x2={ox}     y2={py+ph} stroke={RED} strokeWidth="1.8" strokeDasharray="6 3" opacity="0.4"/>
        <text x={px+pw+5} y={toY(0)+4} fontSize="10" fill="#888">sigma</text>
        <text x={ox+3} y={py+12} fontSize="10" fill="#888">jw</text>

        {/* Closed-loop poles (A-BK) -- slower, closer to origin */}
        {[[-2, 2],[-2,-2],[-3, 0]].map(([r, im], i) => (
          <g key={'cl'+i}>
            <circle cx={toX(r)} cy={toY(im)} r={8} fill={BLUE} opacity="0.9"/>
            {i===0 && <text x={toX(r)+12} y={toY(im)-8} fontSize="10" fill={BLUE} fontWeight="700">eig(A-BK)</text>}
            {i===0 && <text x={toX(r)+12} y={toY(im)+4} fontSize="9" fill={BLUE}>(desired CL poles)</text>}
          </g>
        ))}

        {/* Observer poles (A-LC) -- faster, further left */}
        {[[-8, 4],[-8,-4],[-10, 0]].map(([r, im], i) => (
          <g key={'ob'+i}>
            <rect x={toX(r)-7} y={toY(im)-7} width={14} height={14} rx={2} fill={ORANGE} opacity="0.9"/>
            {i===0 && <text x={toX(r)+12} y={toY(im)-8} fontSize="10" fill={ORANGE} fontWeight="700">eig(A-LC)</text>}
            {i===0 && <text x={toX(r)+12} y={toY(im)+4} fontSize="9" fill={ORANGE}>(observer poles, 3-4x faster)</text>}
          </g>
        ))}

        {/* Speed ratio annotation */}
        {(() => {
          const clX = toX(-2), obX = toX(-8), midY = toY(0) - 24;
          return (
            <g>
              <line x1={clX} y1={midY} x2={obX} y2={midY} stroke="#aaa" strokeWidth="1.5"/>
              <line x1={clX} y1={midY-5} x2={clX} y2={midY+5} stroke={BLUE} strokeWidth="2"/>
              <line x1={obX} y1={midY-5} x2={obX} y2={midY+5} stroke={ORANGE} strokeWidth="2"/>
              <text x={(clX+obX)/2} y={midY-8} textAnchor="middle" fontSize="10" fill="#888">ratio = 8/2 = 4x faster</text>
            </g>
          );
        })()}

        {/* Open-loop poles */}
        {[[-0.5, 1.5],[-0.5,-1.5],[0.8, 0]].map(([r, im], i) => (
          <g key={'ol'+i}>
            <text x={toX(r)} y={toY(im)+5} textAnchor="middle" fontSize="16" fill="#ccc" fontWeight="700">x</text>
            {i===2 && <text x={toX(r)+10} y={toY(im)-8} fontSize="9" fill="#bbb">open-loop</text>}
          </g>
        ))}

        {/* Right info panel */}
        <rect x={558} y={py} width={330} height={ph} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={723} y={py+18} textAnchor="middle" fontSize="13" fill={DKRED} fontWeight="700">Separation Principle</text>

        {[
          { y:py+26, bg:LTBLU, bc:BLUE, lines:[
            'Step 1: Design K (state feedback)',
            'Choose desired CL poles for A-BK',
            'Achieve performance specs (%OS, ts)',
            'Ignore observer for now',
          ]},
          { y:py+110, bg:LTORG, bc:ORANGE, lines:[
            'Step 2: Design L (observer)',
            'Choose observer poles for A-LC',
            'Place 2-5x faster than CL poles',
            'Sigma_obs >= 2 * sigma_cl',
          ]},
          { y:py+194, bg:LTGRN, bc:GREEN, lines:[
            'Combined system poles',
            'Total: eig(A-BK) union eig(A-LC)',
            'n poles from K, n poles from L',
            'Total: 2n poles for nth-order plant',
          ]},
          { y:py+278, bg:LTRED, bc:RED, lines:[
            'Why separation works',
            'Error e does NOT depend on K',
            'State x_hat does NOT depend on L alone',
            'The two designs are truly independent',
          ]},
        ].map(({ y, bg, bc, lines }) => (
          <Card key={y} x={564} y={y} w={318} h={80} bg={bg} bc={bc} lines={lines}/>
        ))}
      </svg>
      <div style={S.dCaption}>
        The separation principle states that the closed-loop poles of the observer-based controller are exactly the union of the poles of (A-BK) and the poles of (A-LC). These two sets can be designed completely independently. Circles represent controller poles; squares represent observer poles. Observer poles must be placed further left to ensure the state estimates are accurate before the controller relies on them.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 5 -- Duality: observer design via transpose trick
// =================================================================
function DiagramDuality() {
  const W = 900, H = 310;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Duality -- Observer Design = State Feedback Design on the Transposed System</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Left panel: state feedback */}
        <rect x={10} y={10} width={405} height={290} rx={5} fill="#fff" stroke={BORDER}/>
        <rect x={10} y={10} width={405} height={36} rx={5} fill={BLUE} opacity="0.1"/>
        <text x={212} y={34} textAnchor="middle" fontSize="14" fill={BLUE} fontWeight="700">State Feedback (A, B) -- Design K</text>

        {[
          { y:54,  color:BLUE,   label:'System',          val:'x_dot = A*x + B*u,  y = C*x' },
          { y:82,  color:BLUE,   label:'Gain matrix',     val:'K is 1xn (SISO) or pxn (MIMO)' },
          { y:110, color:BLUE,   label:'CL system matrix',val:'A_cl = A - B*K' },
          { y:138, color:BLUE,   label:'Char. polynomial',val:'det(sI - (A-BK)) = phi_d(s)' },
          { y:166, color:BLUE,   label:'Controllability', val:'rank(ctrb(A,B)) = n  required' },
          { y:194, color:BLUE,   label:'Ackermann formula',val:'K = e_n^T * C_ctrl^(-1) * phi(A)' },
          { y:222, color:BLUE,   label:'MATLAB',          val:"K = place(A, B, desired_poles)" },
          { y:250, color:BLUE,   label:'LQR alternative', val:'K = R^(-1)*B^T*P  (Riccati)' },
        ].map(({ y, color, label, val }) => (
          <g key={y}>
            <text x={20} y={y+13} fontSize="10" fill={color} fontWeight="700">{label}:</text>
            <text x={20} y={y+27} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">{val}</text>
          </g>
        ))}

        {/* Centre duality arrow */}
        <Arr x1={418} y1={155} x2={438} y2={155} color={GREEN} marker="aGreen" lbl="DUAL" lx={428} ly={147}/>
        <Arr x1={438} y1={165} x2={418} y2={165} color={GREEN} marker="aGreen"/>
        <text x={428} y={182} textAnchor="middle" fontSize="9" fill={GREEN}>A^T, B^T, C^T</text>

        {/* Right panel: observer */}
        <rect x={450} y={10} width={440} height={290} rx={5} fill="#fff" stroke={BORDER}/>
        <rect x={450} y={10} width={440} height={36} rx={5} fill={ORANGE} opacity="0.1"/>
        <text x={670} y={34} textAnchor="middle" fontSize="14" fill={ORANGE} fontWeight="700">Observer Design (A, C) -- Design L</text>

        {[
          { y:54,  color:ORANGE, label:'Dual system',     val:'z_dot = A^T*z + C^T*v  (transposed)' },
          { y:82,  color:ORANGE, label:'Gain matrix',     val:'L is nx1 (SISO) or nxq (MIMO)' },
          { y:110, color:ORANGE, label:'Error system',    val:'A_obs = A - L*C' },
          { y:138, color:ORANGE, label:'Char. polynomial',val:'det(sI - (A-LC)) = phi_obs(s)' },
          { y:166, color:ORANGE, label:'Observability',   val:'rank(obsv(A,C)) = n  required' },
          { y:194, color:ORANGE, label:'Ackermann dual',  val:'L = phi(A) * O_obs^(-1) * e_1' },
          { y:222, color:ORANGE, label:'MATLAB trick',    val:"L = place(A', C', obs_poles)'" },
          { y:250, color:ORANGE, label:'Kalman alt.',     val:'L = P*C^T*R_n^(-1)  (Riccati)' },
        ].map(({ y, color, label, val }) => (
          <g key={y}>
            <text x={460} y={y+13} fontSize="10" fill={color} fontWeight="700">{label}:</text>
            <text x={460} y={y+27} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">{val}</text>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        Duality is the most practical result for observer design: the observer gain L for system (A, C) can be found by solving the state feedback gain problem on the transposed system (A^T, C^T). Every algorithm for pole placement -- Ackermann, Bass-Gura, MATLAB place(), LQR -- works directly for observer design via this transpose trick. L = place(A^T, C^T, obs_poles)^T gives the observer gain in one line. The observability requirement mirrors the controllability requirement for state feedback.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 6 -- Ackermann observer formula walkthrough
// =================================================================
function DiagramAckermannObserver() {
  const W = 900, H = 330;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Observer Ackermann Formula -- Step-by-Step with Worked Example</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Formula banner */}
        <rect x={10} y={10} width={880} height={50} rx={4} fill={LTORG} stroke={ORANGE} strokeWidth="1.5"/>
        <text x={450} y={33} textAnchor="middle" fontSize="14" fill={ORANGE} fontWeight="700"
          fontFamily="'Courier New',monospace">L = phi_d(A) * O^(-1) * e_1</text>
        <text x={450} y={51} textAnchor="middle" fontSize="10" fill="#555">
          phi_d(A): desired obs. poly evaluated at A   |   O: observability matrix   |   e_1 = [1;0;...;0] (first basis vector)
        </text>

        {/* Steps */}
        {[
          { x:10,  w:210, num:'1', color:BLUE,   bg:LTBLU,
            title:'Desired observer poles',
            body:['Choose obs. poles (2-4x faster)','e.g., p_obs = {-8, -8+/-j4}','Expand: phi_d(s) = (s+8)(s+8+j4)(s+8-j4)','phi_d(s) = s^3 + 24s^2 + 208s + 640'] },
          { x:228, w:210, num:'2', color:GREEN,  bg:LTGRN,
            title:'Observability matrix O',
            body:['O = [C; C*A; C*A^2; ...; C*A^(n-1)]','Must have rank(O) = n','O^(-1) exists iff system is observable','MATLAB: obsv(A,C)'] },
          { x:446, w:210, num:'3', color:PURPLE, bg:LTPUR,
            title:'Evaluate phi_d(A)',
            body:['Substitute matrix A into phi_d(s)','phi_d(A) = A^3 + 24*A^2 + 208*A + 640*I','Result is n x n matrix','Uses Cayley-Hamilton theorem'] },
          { x:664, w:226, num:'4', color:ORANGE, bg:LTORG,
            title:'Compute L',
            body:['L = phi_d(A) * O^(-1) * e_1','e_1 = [1;0;...;0] (first column selector)','Result: L is n x 1 column vector','Or use MATLAB duality trick'] },
        ].map(({ x, w, num, color, bg, title, body }) => (
          <g key={x}>
            <rect x={x} y={70} width={w} height={170} rx={4} fill="#fff" stroke={BORDER}/>
            <rect x={x} y={70} width={w} height={36} rx={4} fill={color} opacity="0.12"/>
            <circle cx={x+18} cy={88} r={12} fill={color}/>
            <text x={x+18} y={92} textAnchor="middle" fontSize="12" fill="#fff" fontWeight="700">{num}</text>
            <text x={x+36} y={84} fontSize="11" fill={color} fontWeight="700">{title}</text>
            {body.map((t, i) => (
              <text key={i} x={x+8} y={116+i*18} fontSize="9.5" fill="#333">{t}</text>
            ))}
          </g>
        ))}

        {/* Step arrows */}
        {[220, 438, 656].map((x, i) => (
          <Arr key={'sa'+i} x1={x} y1={155} x2={x+8} y2={155} color="#bbb" marker="aGray"/>
        ))}

        {/* Worked example */}
        <rect x={10} y={252} width={880} height={70} rx={4} fill="#fff" stroke={BORDER}/>
        <text x={450} y={270} textAnchor="middle" fontSize="12" fill={DKRED} fontWeight="700">Worked Example: n=2, A=[[0,1],[-2,-3]], C=[1,0], desired obs. poles at s=-8,-10</text>

        {[
          { x:20,  color:BLUE,   text:['phi_d(s) = (s+8)(s+10) = s^2+18s+80'] },
          { x:250, color:GREEN,  text:['O = [C;CA] = [[1,0],[0,1]] = I_2'] },
          { x:480, color:PURPLE, text:['phi_d(A) = A^2+18A+80I = [[76,15],[-30,22]]'] },
          { x:700, color:ORANGE, text:['L = phi_d(A)*I^(-1)*e_1 = [76;-30]'] },
        ].map(({ x, color, text }) => (
          <g key={x}>
            <rect x={x} y={278} width={220} height={36} rx={3} fill="#fafafa" stroke={color} strokeWidth="0.8"/>
            {text.map((t, i) => (
              <text key={i} x={x+6} y={293+i*15} fontSize="9.5" fill="#333" fontFamily="'Courier New',monospace">{t}</text>
            ))}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        The observer Ackermann formula L = phi_d(A) * O^(-1) * e_1 mirrors exactly the state feedback formula K = e_n^T * C^(-1) * phi_d(A). The observability matrix O plays the role of the controllability matrix C, and e_1 (first basis vector) plays the role of e_n^T. In the worked example with a 2x2 system, the observability matrix happens to be the identity, making the calculation straightforward. In practice, use MATLAB: L = place(A^T, C^T, obs_poles)^T.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 7 -- Separation principle: combined system poles
// =================================================================
function DiagramSeparation() {
  const W = 900, H = 380;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Separation Principle -- The Combined Observer-Controller System</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Left: Augmented state equation */}
        <rect x={10} y={10} width={420} height={360} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={220} y={28} textAnchor="middle" fontSize="13" fill={DKRED} fontWeight="700">Augmented State-Space Representation</text>

        <rect x={18} y={36} width={404} height={58} rx={3} fill={LTBLU} stroke={BLUE} strokeWidth="1.5"/>
        <text x={220} y={55} textAnchor="middle" fontSize="11" fill={BLUE} fontWeight="700" fontFamily="'Courier New',monospace">State vector: [x; e_obs]  where e_obs = x - x_hat</text>
        <text x={220} y={72} textAnchor="middle" fontSize="10" fill="#555" fontFamily="'Courier New',monospace">Size 2n x 1  (n plant states + n error states)</text>

        {/* Block matrix */}
        <text x={22} y={110} fontSize="11" fill={DKRED} fontWeight="700">Augmented system matrix (block upper triangular):</text>

        <rect x={22}  y={118} width={180} height={80} rx={3} fill={LTBLU} stroke={BLUE} strokeWidth="1"/>
        <rect x={206} y={118} width={180} height={80} rx={3} fill={LTGRN} stroke={GREEN} strokeWidth="1"/>
        <rect x={22}  y={202} width={180} height={80} rx={3} fill="#fafafa" stroke="#ddd" strokeWidth="1"/>
        <rect x={206} y={202} width={180} height={80} rx={3} fill={LTORG} stroke={ORANGE} strokeWidth="1"/>

        {/* Matrix labels */}
        <text x={112} y={162} textAnchor="middle" fontSize="14" fill={BLUE} fontWeight="700" fontFamily="'Courier New',monospace">A - B*K</text>
        <text x={296} y={162} textAnchor="middle" fontSize="14" fill={GREEN} fontWeight="700" fontFamily="'Courier New',monospace">B*K</text>
        <text x={112} y={246} textAnchor="middle" fontSize="14" fill="#bbb" fontWeight="700" fontFamily="'Courier New',monospace">0</text>
        <text x={296} y={246} textAnchor="middle" fontSize="14" fill={ORANGE} fontWeight="700" fontFamily="'Courier New',monospace">A - L*C</text>

        {/* Bracket */}
        <line x1={16} y1={114} x2={16} y2={286} stroke="#555" strokeWidth="2.5"/>
        <line x1={392} y1={114} x2={392} y2={286} stroke="#555" strokeWidth="2.5"/>
        <line x1={16} y1={114} x2={22} y2={114} stroke="#555" strokeWidth="2.5"/>
        <line x1={16} y1={286} x2={22} y2={286} stroke="#555" strokeWidth="2.5"/>
        <line x1={392} y1={114} x2={386} y2={114} stroke="#555" strokeWidth="2.5"/>
        <line x1={392} y1={286} x2={386} y2={286} stroke="#555" strokeWidth="2.5"/>

        <text x={22} y={304} fontSize="11" fill={DKRED} fontWeight="700">Eigenvalues of this matrix =</text>
        <text x={22} y={320} fontSize="11" fill={BLUE} fontWeight="700">  eig(A-BK)  UNION  eig(A-LC)</text>
        <text x={22} y={338} fontSize="10" fill="#444">Block triangular: eigenvalues are those of each diagonal block</text>
        <text x={22} y={354} fontSize="10" fill="#444">The two blocks are INDEPENDENT -- separation is exact</text>

        {/* Right: Implications */}
        <rect x={448} y={10} width={442} height={360} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={669} y={28} textAnchor="middle" fontSize="13" fill={DKRED} fontWeight="700">Implications of the Separation Principle</text>

        {[
          { y:36,  bg:LTGRN, bc:GREEN, lines:[
            '[OK] Independent design',
            'Design K using A,B as if full state available',
            'Design L using A,C independently',
            'No iteration between the two designs needed',
          ]},
          { y:116, bg:LTBLU, bc:BLUE, lines:[
            '[OK] Same stability conditions',
            'Combined system stable if BOTH are stable:',
            '  eig(A-BK) all in LHP  (controller stable)',
            '  eig(A-LC) all in LHP  (observer stable)',
          ]},
          { y:196, bg:LTORG, bc:ORANGE, lines:[
            '[OK] Pole placement unchanged',
            'Adding observer does NOT move CL poles of A-BK',
            'Controller performance preserved exactly',
            'Only observer transient added on top',
          ]},
          { y:276, bg:LTRED, bc:RED, lines:[
            '[!] Limitation -- linear systems only',
            'Separation principle holds ONLY for LTI systems',
            'For nonlinear: observer error couples into controller',
            'Use nonlinear observer or extended Kalman filter',
          ]},
        ].map(({ y, bg, bc, lines }) => (
          <Card key={y} x={454} y={y} w={430} h={76} bg={bg} bc={bc} lines={lines}/>
        ))}
      </svg>
      <div style={S.dCaption}>
        The augmented 2n x 2n system matrix is block upper triangular, with A-BK in the top-left and A-LC in the bottom-right. Its eigenvalues are exactly the union of both sets of poles. This block triangular structure is the mathematical proof of the separation principle: the two diagonal blocks are independent, so K and L can be designed in isolation. The zero lower-left block means the estimation error does not feed into the plant state dynamics.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 8 -- Observer vs full-state: step response comparison
// =================================================================
function DiagramResponseComparison() {
  const W = 900, H = 360;
  const bx = 60, by = 30, bw = 520, bh = 280;
  const tMax = 5.0;
  const toX = t => bx + (t / tMax) * bw;
  const toY = v => by + bh - Math.min(Math.max(v, -0.1), 1.6) * bh * 0.75;

  // Generate step responses
  const genResponse = (sigma, zeta, wn, delay, scale) => {
    return Array.from({ length: 100 }, (_, k) => {
      const t = Math.max(0, k * tMax / 99 - delay);
      const wd = wn * Math.sqrt(Math.max(0, 1 - zeta * zeta));
      let v;
      if (zeta >= 1) {
        const r1 = -zeta * wn + wn * Math.sqrt(zeta*zeta - 1);
        const r2 = -zeta * wn - wn * Math.sqrt(zeta*zeta - 1);
        v = 1 - (r2 * Math.exp(r1*t) - r1 * Math.exp(r2*t)) / (r2 - r1);
      } else {
        v = 1 - Math.exp(-zeta * wn * t) * (Math.cos(wd * t) + (zeta / Math.sqrt(1 - zeta*zeta)) * Math.sin(wd * t));
      }
      return toX(k * tMax / 99) + ',' + toY(v * scale);
    }).join(' ');
  };

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Step Response -- Full-State Feedback vs Observer-Based Controller</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Plot */}
        <rect x={bx} y={by} width={bw} height={bh} rx={4} fill="#fff" stroke={BORDER}/>

        {/* Grid */}
        {[0, 0.25, 0.5, 0.75, 1.0, 1.25].map(v => (
          <g key={'hg'+v}>
            <line x1={bx} y1={toY(v)} x2={bx+bw} y2={toY(v)} stroke="#f5f0f0" strokeWidth="1"/>
            <text x={bx-6} y={toY(v)+4} textAnchor="end" fontSize="10" fill="#bbb">{v.toFixed(2)}</text>
          </g>
        ))}
        {[0,1,2,3,4,5].map(t => (
          <g key={'vg'+t}>
            <line x1={toX(t)} y1={by} x2={toX(t)} y2={by+bh} stroke="#f5f0f0" strokeWidth="1"/>
            <text x={toX(t)} y={by+bh+14} textAnchor="middle" fontSize="10" fill="#bbb">{t}</text>
          </g>
        ))}

        {/* Reference */}
        <line x1={bx} y1={toY(1)} x2={bx+bw} y2={toY(1)} stroke="#bbb" strokeWidth="1.5" strokeDasharray="5 3"/>
        <text x={bx+bw-4} y={toY(1)-5} textAnchor="end" fontSize="10" fill="#999">r = 1</text>

        {/* Axes */}
        <line x1={bx} y1={by+bh} x2={bx+bw} y2={by+bh} stroke="#aaa" strokeWidth="1.3"/>
        <line x1={bx} y1={by}    x2={bx}    y2={by+bh} stroke="#aaa" strokeWidth="1.3"/>
        <text x={bx+bw/2} y={by+bh+26} textAnchor="middle" fontSize="11" fill="#777">Time (s)</text>
        <text x={bx-38} y={by+bh/2} textAnchor="middle" fontSize="11" fill="#777"
          transform={'rotate(-90,' + (bx-38) + ',' + (by+bh/2) + ')'}>Output y(t)</text>

        {/* Full-state feedback (ideal) */}
        <polyline points={genResponse(2, 0.7, 2.86, 0, 1)} fill="none" stroke={BLUE} strokeWidth="2.5"/>

        {/* Observer-based, fast observer (sigma_obs=10): nearly identical */}
        <polyline points={genResponse(2, 0.7, 2.86, 0.05, 1)} fill="none" stroke={GREEN} strokeWidth="2" strokeDasharray="8 3"/>

        {/* Observer-based, medium observer (sigma_obs=4): slight initial difference */}
        <polyline points={genResponse(1.8, 0.72, 2.8, 0.12, 1)} fill="none" stroke={ORANGE} strokeWidth="2" strokeDasharray="5 3"/>

        {/* Observer-based, slow observer: poor initial response */}
        <polyline points={genResponse(1.4, 0.8, 2.6, 0.35, 1)} fill="none" stroke={RED} strokeWidth="2" strokeDasharray="4 3"/>

        {/* Legend */}
        {[
          { color:BLUE,   dash:false, lbl:'Full-state feedback (ideal, all states measured)' },
          { color:GREEN,  dash:true,  lbl:'Observer-based, fast obs. poles (sigma_obs = 10): near-ideal' },
          { color:ORANGE, dash:true,  lbl:'Observer-based, medium obs. poles (sigma_obs = 4): good' },
          { color:RED,    dash:true,  lbl:'Observer-based, slow obs. poles (sigma_obs = 1): poor initial' },
        ].map(({ color, dash, lbl }, i) => (
          <g key={'leg'+i}>
            <line x1={bx+10} y1={by+16+i*26} x2={bx+42} y2={by+16+i*26}
              stroke={color} strokeWidth="2.2" strokeDasharray={dash ? '6 3' : 'none'}/>
            <text x={bx+46} y={by+20+i*26} fontSize="10" fill={color} fontWeight="700">{lbl}</text>
          </g>
        ))}

        {/* Right panel */}
        <rect x={600} y={by} width={286} height={bh} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={743} y={by+16} textAnchor="middle" fontSize="12" fill={DKRED} fontWeight="700">What to Observe</text>

        {[
          { y:by+24, bg:LTBLU,  bc:BLUE,   lines:['Full-state (ideal)', 'Exact performance','Only possible if all x measurable'] },
          { y:by+86, bg:LTGRN,  bc:GREEN,  lines:['Fast observer result','Virtually identical to ideal','Observer transient is invisible'] },
          { y:by+148, bg:LTORG, bc:ORANGE, lines:['Medium observer result','Tiny initial difference','Steady state matches exactly'] },
          { y:by+210, bg:LTRED, bc:RED,    lines:['Slow observer result','Observable error initial phase','Observer must converge first'] },
        ].map(({ y, bg, bc, lines }) => (
          <Card key={y} x={606} y={y} w={274} h={58} bg={bg} bc={bc} lines={lines}/>
        ))}
      </svg>
      <div style={S.dCaption}>
        When observer poles are placed sufficiently faster than the closed-loop poles, the observer-based step response is virtually indistinguishable from ideal full-state feedback. The initial transient difference shrinks as observer speed increases. Slower observers show a visible initial error phase where the controller operates on poor state estimates. The steady-state response is always identical because the observer error converges to zero for any stable observer.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 9 -- Kalman filter comparison
// =================================================================
function DiagramKalmanComparison() {
  const W = 900, H = 360;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Luenberger Observer vs Kalman Filter -- When to Use Which</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Header */}
        <rect x={10} y={10} width={880} height={36} rx={4} fill="#f9f9f9" stroke={BORDER}/>
        <text x={230} y={33} textAnchor="middle" fontSize="13" fill={BLUE} fontWeight="700">Luenberger Observer</text>
        <text x={670} y={33} textAnchor="middle" fontSize="13" fill={ORANGE} fontWeight="700">Kalman Filter (Optimal Observer)</text>

        {/* Comparison rows */}
        {[
          { label:'Design input',
            lu:'Desired observer pole locations (eigenvalues of A-LC)',
            kf:'Process noise Q_w and measurement noise R_v covariances' },
          { label:'Optimal criterion',
            lu:'No optimality criterion -- user-specified poles',
            kf:'Minimises steady-state estimation error covariance E[e*e^T]' },
          { label:'Gain L computation',
            lu:'L = place(A^T, C^T, poles)^T  or  Ackermann dual',
            kf:'L = P*C^T*R_v^(-1)  where P solves the Riccati equation' },
          { label:'Riccati equation',
            lu:'Not used (L chosen directly from pole locations)',
            kf:'A*P + P*A^T - P*C^T*R_v^(-1)*C*P + Q_w = 0  (solve for P)' },
          { label:'Noise handling',
            lu:'No noise model -- faster poles amplify noise more',
            kf:'Explicitly trades off process and measurement noise' },
          { label:'Model required',
            lu:'Nominal A, B, C matrices (exact model assumed)',
            kf:'A, B, C  PLUS  noise covariance matrices Q_w and R_v' },
          { label:'Computational cost',
            lu:'Low -- L is a constant matrix, no online computation',
            kf:'Steady-state: same as Luenberger (precompute P offline)' },
          { label:'When to use',
            lu:'No significant noise; pole locations clearly specified',
            kf:'Measurement or process noise present; want optimal estimate' },
        ].map(({ label, lu, kf }, i) => {
          const y = 52 + i * 38;
          const bg = i % 2 === 0 ? '#fafafa' : '#fff';
          return (
            <g key={i}>
              <rect x={10} y={y} width={880} height={36} fill={bg} stroke="#eee" strokeWidth="0.5"/>
              <rect x={10} y={y} width={200} height={36} fill={i===0?LTBLU:'#f5f8ff'} stroke="#eee" strokeWidth="0.5"/>
              <text x={18} y={y+23} fontSize="10" fill={DKRED} fontWeight="700">{label}</text>
              <line x1={210} y1={y} x2={210} y2={y+36} stroke="#eee" strokeWidth="1"/>
              <text x={218} y={y+14} fontSize="9.5" fill={BLUE}>{lu}</text>
              <line x1={550} y1={y} x2={550} y2={y+36} stroke="#eee" strokeWidth="1"/>
              <text x={558} y={y+14} fontSize="9.5" fill={ORANGE}>{kf}</text>
            </g>
          );
        })}

        {/* Summary boxes */}
        <rect x={10}  y={358} width={420} height={0} rx={3}/>
        <rect x={450} y={358} width={440} height={0} rx={3}/>
      </svg>
      <div style={S.dCaption}>
        The Luenberger observer and Kalman filter are both special cases of the same observer structure x_hat_dot = A*x_hat + B*u + L*(y - C*x_hat). The difference is how L is chosen: Luenberger uses pole placement (designer specifies eigenvalues of A-LC), while the Kalman filter minimises the estimation error covariance by solving a Riccati equation. For deterministic systems with clean sensors, Luenberger is simpler and sufficient. When noise matters, use the Kalman filter.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 10 -- Full observer-based output feedback system
// =================================================================
function DiagramOutputFeedback() {
  const W = 900, H = 320;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Output Feedback Controller -- Transfer Function from y to u</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* The combined observer+K forms a dynamic controller C(s) */}
        <rect x={10} y={10} width={880} height={60} rx={5} fill={LTPUR} stroke={PURPLE} strokeWidth="1.5"/>
        <text x={450} y={33} textAnchor="middle" fontSize="13" fill={PURPLE} fontWeight="700">
          Combined Observer + K forms a Dynamic Output Feedback Controller C(s)
        </text>
        <text x={450} y={53} textAnchor="middle" fontSize="10" fill="#555"
          fontFamily="'Courier New',monospace">
          C(s) = K * (sI - A + BK + LC)^(-1) * L   (transfer function from y to u)
        </text>

        {/* Block diagram: r -> [N] -> [+] -> [C(s)] -> [Plant] -> y  with feedback */}
        <Arr x1={14} y1={164} x2={56} y2={164} color={RED} marker="aRed"/>
        <text x={8} y={159} fontSize="12" fill={RED} fontWeight="700">r</text>
        <Blk x={56} y={146} w={50} h={36} fill={LTPUR} stroke={PURPLE} label="N" fs={11}/>
        <Arr x1={106} y1={164} x2={134} y2={164} color={PURPLE} marker="aPurple"/>
        <circle cx={152} cy={164} r={16} fill="#fff" stroke={RED} strokeWidth="1.8"/>
        <text x={152} y={170} textAnchor="middle" fontSize="15" fill={RED} fontWeight="700">+</text>
        <text x={141} y={152} fontSize="10" fill={RED}>+</text>
        <text x={141} y={178} fontSize="10" fill={RED}>-</text>
        <Arr x1={168} y1={164} x2={204} y2={164} color={RED} marker="aRed"/>

        {/* Dynamic controller box */}
        <rect x={204} y={130} width={200} height={68} rx={5} fill={LTPUR} stroke={PURPLE} strokeWidth="2"/>
        <text x={304} y={155} textAnchor="middle" fontSize="13" fill={PURPLE} fontWeight="700">C(s)</text>
        <text x={304} y={170} textAnchor="middle" fontSize="10" fill={PURPLE}>Observer + K</text>
        <text x={304} y={183} textAnchor="middle" fontSize="9" fill="#555">x_hat_dot=A*x_hat+B*u+L*(y-C*x_hat)</text>
        <text x={304} y={194} textAnchor="middle" fontSize="9" fill="#555">u = -K*x_hat</text>

        <Arr x1={404} y1={164} x2={450} y2={164} color={PURPLE} marker="aPurple" lbl="u" lx={427} ly={156}/>

        {/* Plant */}
        <Blk x={450} y={138} w={150} h={52} fill={LTBLU} stroke={BLUE} label="PLANT G(s)" sub="x_dot=Ax+Bu, y=Cx"/>
        <Arr x1={600} y1={164} x2={680} y2={164} color={BLUE} marker="aBlue" lbl="y" lx={638} ly={156}/>
        <circle cx={648} cy={164} r={5} fill={BLUE}/>

        {/* Feedback y to summer */}
        <line x1={648} y1={164} x2={648} y2={248} stroke={BLUE} strokeWidth="1.8"/>
        <line x1={648} y1={248} x2={152} y2={248} stroke={BLUE} strokeWidth="1.8"/>
        <Arr x1={152} y1={248} x2={152} y2={180} color={BLUE} marker="aBlue"/>

        {/* y also to controller */}
        <line x1={648} y1={164} x2={700} y2={164} stroke={BLUE} strokeWidth="1.8"/>
        <line x1={700} y1={164} x2={700} y2={280} stroke={BLUE} strokeWidth="1.8"/>
        <line x1={700} y1={280} x2={304} y2={280} stroke={BLUE} strokeWidth="1.8"/>
        <Arr x1={304} y1={280} x2={304} y2={198} color={BLUE} marker="aBlue"/>
        <text x={502} y={276} fontSize="10" fill={BLUE} fontWeight="600">y fed to observer</text>

        {/* Order annotation */}
        <rect x={10} y={260} width={280} height={52} rx={4} fill={LTPUR} stroke={PURPLE} strokeWidth="1"/>
        <text x={18} y={276} fontSize="11" fill={PURPLE} fontWeight="700">Order of C(s):</text>
        <text x={18} y={292} fontSize="10" fill="#444">C(s) has order n (same as plant)</text>
        <text x={18} y={306} fontSize="10" fill="#444">Total closed-loop order = 2n</text>

        {/* Right info */}
        <rect x={720} y={96} width={170} height={220} rx={4} fill="#fff" stroke={BORDER}/>
        <text x={805} y={114} textAnchor="middle" fontSize="11" fill={DKRED} fontWeight="700">C(s) Properties</text>
        {[
          { y:120, bg:LTPUR, bc:PURPLE, lines:['Dynamic controller','Has its own states (x_hat)','Order = n (not just a gain)'] },
          { y:170, bg:LTGRN, bc:GREEN,  lines:['Poles of C(s)','Located at eig(A-BK-LC)','Different from obs/ctrl poles'] },
          { y:220, bg:LTBLU, bc:BLUE,   lines:['Observer canonical','Can be written in standard','controller canonical form'] },
          { y:270, bg:LTORG, bc:ORANGE, lines:['LQG controller','L from Kalman + K from LQR','= Linear Quadratic Gaussian'] },
        ].map(({ y, bg, bc, lines }) => (
          <Card key={y} x={726} y={y} w={158} h={46} bg={bg} bc={bc} lines={lines}/>
        ))}
      </svg>
      <div style={S.dCaption}>
        The combined observer and state feedback law u = -K*x_hat forms a dynamic output feedback controller C(s) that takes only the measured output y as input and produces u. Its transfer function is C(s) = K*(sI - A + BK + LC)^(-1)*L. This controller has order n (one integrator-like state per plant state), making the total closed-loop system order 2n. When L comes from a Kalman filter and K from LQR, this combination is called the Linear Quadratic Gaussian (LQG) controller.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 11 -- Reduced-order observer
// =================================================================
function DiagramReducedOrder() {
  const W = 900, H = 290;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Reduced-Order Observer -- Estimating Only the Unmeasured States</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Concept panels */}
        <rect x={10} y={10} width={420} height={270} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={220} y={28} textAnchor="middle" fontSize="13" fill={DKRED} fontWeight="700">Why a Reduced-Order Observer?</text>

        {/* State partitioning visual */}
        <rect x={20} y={36} width={400} height={80} rx={4} fill="#fafafa" stroke={BORDER}/>
        <text x={220} y={54} textAnchor="middle" fontSize="11" fill="#555">Partition state x = [x_a ; x_b]</text>
        <rect x={30}  y={62} width={120} height={44} rx={3} fill={LTGRN} stroke={GREEN} strokeWidth="1.5"/>
        <text x={90}  y={82} textAnchor="middle" fontSize="12" fill={GREEN} fontWeight="700">x_a</text>
        <text x={90}  y={96} textAnchor="middle" fontSize="9" fill={GREEN}>MEASURED directly</text>
        <text x={90}  y={108} textAnchor="middle" fontSize="9" fill={GREEN}>(via y = C*x)</text>
        <rect x={170} y={62} width={120} height={44} rx={3} fill={LTPUR} stroke={PURPLE} strokeWidth="1.5"/>
        <text x={230} y={82} textAnchor="middle" fontSize="12" fill={PURPLE} fontWeight="700">x_b</text>
        <text x={230} y={96} textAnchor="middle" fontSize="9" fill={PURPLE}>MUST BE ESTIMATED</text>
        <text x={230} y={108} textAnchor="middle" fontSize="9" fill={PURPLE}>(not directly sensed)</text>
        <text x={330} y={84} fontSize="11" fill="#888">n-q states</text>
        <text x={330} y={98} fontSize="9" fill="#888">need observer</text>

        {[
          { y:124, color:PURPLE, bg:LTPUR, lines:['Full-order observer (standard)',    'Estimates ALL n states including measured ones','Order n: wastes effort re-estimating known x_a'] },
          { y:166, color:GREEN,  bg:LTGRN, lines:['Reduced-order observer',            'Only estimates the n-q UNKNOWN states x_b','Order n-q: simpler, faster, less noise'] },
          { y:208, color:ORANGE, bg:LTORG, lines:['Key idea','Since x_a = y (known exactly via sensor)','Use x_a directly + estimate only x_b'] },
        ].map(({ y, color, bg, lines }) => (
          <Card key={y} x={20} y={y} w={400} h={42} bg={bg} bc={color} lines={lines}/>
        ))}

        {/* Right: reduced observer equations */}
        <rect x={450} y={10} width={440} height={270} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={670} y={28} textAnchor="middle" fontSize="13" fill={DKRED} fontWeight="700">Reduced-Order Observer Equations</text>

        {[
          { y:36,  color:BLUE,   bg:LTBLU,  lines:['Partition the system matrices',
            'A = [[A_aa, A_ab]; [A_ba, A_bb]]',
            'B = [[B_a]; [B_b]],  y = x_a = C*x'] },
          { y:96,  color:PURPLE, bg:LTPUR,  lines:['Define transformed variable',
            'z = x_b - L_r * x_a  (observer state)',
            'Reduces coupling between known and unknown'] },
          { y:156, color:ORANGE, bg:LTORG,  lines:['Reduced observer dynamics',
            'z_dot = (A_bb - L_r*A_ab)*z + (known terms)',
            'Error: e_r_dot = (A_bb - L_r*A_ab)*e_r -> 0'] },
          { y:216, color:GREEN,  bg:LTGRN,  lines:['Design L_r',
            'Place eigenvalues of (A_bb - L_r*A_ab)',
            'Only n-q poles to specify (not n)'] },
        ].map(({ y, color, bg, lines }) => (
          <Card key={y} x={456} y={y} w={428} h={56} bg={bg} bc={color} lines={lines}/>
        ))}
      </svg>
      <div style={S.dCaption}>
        If q outputs are measured directly, a reduced-order observer only needs to estimate the remaining n-q states. Since x_a is already known from y, there is no need to re-estimate it. The reduced observer has order n-q with gain L_r (not the full L), and its error dynamics are governed by (A_bb - L_r*A_ab). This gives a simpler, lower-order controller that introduces less noise and has fewer poles to place. For single-output systems (q=1), only n-1 states need estimation.
      </div>
    </div>
  );
}

// =================================================================
// Main
// =================================================================
export default function LuenbergerObserver() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>The Luenberger Observer</h1>
      <p style={S.p}>
        Full-state feedback u = -Kx requires knowledge of all state variables x(t). In most real systems, only a few outputs y(t) = Cx(t) are measured -- internal states like velocity, current, or temperature may be inaccessible. The Luenberger observer (1964) solves this problem by running a software copy of the plant model in real time, injecting the output measurement error to correct any drift. The result is an estimated state x_hat that converges to the true x, allowing state feedback to be implemented using only sensor measurements.
      </p>

      <InfoBox title="Core Ideas at a Glance" items={[
        "Observer equation: x_hat_dot = A*x_hat + B*u + L*(y - C*x_hat)  (software model with correction)",
        "Innovation: e_innov = y - C*x_hat  (output prediction error -- drives the correction)",
        "Error dynamics: (x - x_hat)_dot = (A - L*C)*(x - x_hat)  -- error decays if eig(A-LC) in LHP",
        "Design L: place eigenvalues of (A-LC) by choosing gain matrix L (n x q for q outputs)",
        "Duality: designing L for (A,C) is identical to designing K for the transposed system (A^T, C^T)",
        "Observer poles should be 2-5x faster than closed-loop poles (higher sigma_obs vs sigma_cl)",
        "Separation principle: K and L can be designed independently -- combined poles = eig(A-BK) U eig(A-LC)",
        "MATLAB: L = place(A^T, C^T, obs_poles)^T  or  L = (lqr(A^T, C^T, Q, R))^T for Kalman",
        "Reduced-order observer: estimates only n-q unmeasured states when q outputs are directly available",
      ]}/>

      <h2 style={S.h2}>Observer Block Diagram</h2>
      <p style={S.p}>
        The observer sits alongside the physical plant, receiving the same control input u(t) and the measured output y(t). It maintains its own state estimate x_hat by running the plant model and continuously correcting that model using the difference between the real output and the predicted output. The correction gain L determines how aggressively the estimate is pulled toward the measurements.
      </p>
      <DiagramBlockDiagram/>
      <Table2 rows={[
        ["Plant (physical)","x_dot = A*x + B*u,  y = C*x + v  (v = measurement noise)\nTrue states x are generally unavailable for direct feedback"],
        ["Observer model","x_hat_dot = A*x_hat + B*u + L*(y - C*x_hat)\nSame A, B, C matrices as plant; L is the design variable"],
        ["Innovation","e_innov = y - C*x_hat = y - y_hat\nDifference between measured and predicted output -- the correction signal"],
        ["Correction term","L * (y - C*x_hat): injects output error back into state estimate\nWithout L: pure open-loop simulator, any error accumulates forever"],
        ["Output feedback","u = -K*x_hat  (use estimate, not true state)","Observer enables state feedback when states are not directly measurable"],
        ["Closed-loop output TF","C(s) = K*(sI - A + BK + LC)^(-1)*L\nCombined observer+K is a dynamic controller of order n"],
      ]}/>

      <h2 style={S.h2}>Observer Equation Anatomy and Error Dynamics</h2>
      <p style={S.p}>
        The three terms in the observer equation each have a clear role. The A*x_hat term propagates the model forward using the system dynamics. The B*u term accounts for the known input. The correction term L*(y - C*x_hat) injects measured output information to prevent the estimate from drifting. Subtracting the observer from the plant equation gives the error dynamics e_dot = (A - L*C)*e, which is the key design equation.
      </p>
      <DiagramEquationAnatomy/>
      <Table2 rows={[
        ["Error definition","e_obs(t) = x(t) - x_hat(t)  (true minus estimated)","Measures how far the estimate is from the truth at each instant"],
        ["Error dynamics","e_dot = (A - L*C)*e_obs\nHomogeneous ODE: error evolves independently of u(t) and x(0)"],
        ["Stability condition","All eigenvalues of (A - L*C) must have negative real parts\nEnsures e_obs(t) -> 0 as t -> inf for any initial error e_obs(0)"],
        ["Convergence rate","Error decays as exp(eig(A-LC)*t) times initial error e_obs(0)\nFaster eigenvalues (more negative) = faster convergence"],
        ["Why L matters","Without L (L=0): A-LC = A; if A has unstable modes, error grows\nWith L: eigenvalues of A-LC can be placed anywhere (if observable)"],
        ["Observability requirement","Can place eig(A-LC) anywhere iff (A,C) is observable\nIf not fully observable: can only stabilise observable modes"],
      ]}/>

      <h2 style={S.h2}>Error Convergence and Speed Trade-offs</h2>
      <p style={S.p}>
        The rate at which the observer error converges to zero is determined by the eigenvalues of A - L*C. Placing these eigenvalues further left in the s-plane gives faster convergence, but also increases the magnitude of L, which amplifies measurement noise. This fundamental trade-off shapes every observer design decision.
      </p>
      <DiagramErrorConvergence/>
      <Table2 rows={[
        ["Observer speed rule","Place observer poles 2 to 5 times faster than closed-loop poles\nsigma_obs = 2 to 5 * sigma_cl where sigma = |Re(s)|"],
        ["Too slow","If observer poles are slower than CL poles, the controller acts on stale estimates\nPoor initial transient; may cause degraded performance or instability"],
        ["Too fast","Very large L entries amplify measurement noise into x_hat\nNoisy x_hat degrades control quality despite fast convergence"],
        ["Noise amplification","Noise power at output of L is proportional to ||L||^2 * noise_variance\nDoubling observer speed roughly quadruples noise sensitivity"],
        ["Guideline for initial design","Start with obs. poles at 3-5x the dominant CL pole magnitude\nSimulate both error convergence and noise sensitivity before finalising"],
        ["Kalman filter solution","When noise levels are known, optimal L minimises estimation error variance\nL_opt = P*C^T*R_v^(-1) where P solves the observability Riccati equation"],
      ]}/>

      <h2 style={S.h2}>s-Plane: Observer and Controller Poles</h2>
      <p style={S.p}>
        Visualising both sets of poles in the s-plane makes the separation principle concrete. The controller poles (eigenvalues of A-BK) determine the closed-loop performance; the observer poles (eigenvalues of A-LC) determine how quickly the state estimates converge. Both must be in the left-half plane for the combined system to be stable, and the observer poles are placed further left to ensure estimates are accurate before the controller relies on them.
      </p>
      <DiagramSPlaneDual/>
      <Table2 rows={[
        ["Total system poles","Combined: eig(A-BK) union eig(A-LC)  -- 2n poles total\nBlock-triangular structure: no mixing between the two sets"],
        ["Controller poles","Designed for performance: settle by time ts, overshoot < %OS\neig(A-BK) placed inside desired s-plane region"],
        ["Observer poles","Designed for convergence: sigma_obs = (2 to 5) * sigma_cl\neig(A-LC) placed further left; specific damping less critical"],
        ["Observer damping","Observer damping ratio less critical than controller damping\nOften choose real observer poles to simplify L computation"],
        ["Rule of thumb","For 2nd order: obs poles at s = -3*sigma_cl (real, repeated)\nFor higher order: scale all observer poles by factor of 3-5"],
        ["Effect on sensitivity","Observer poles further left = better estimates but larger L\nL grows roughly linearly with observer pole magnitude"],
      ]}/>

      <h2 style={S.h2}>Duality: Observer Design via Transpose</h2>
      <p style={S.p}>
        The most practical result for observer design is the duality between controllability and observability: designing L for system (A, C) is mathematically identical to designing K for the transposed system (A^T, C^T). Every pole placement algorithm -- Ackermann, MATLAB place(), LQR -- works directly for observer design by transposing the matrices. This means no new theory is needed; everything learned for state feedback applies immediately.
      </p>
      <DiagramDuality/>
      <Table2 rows={[
        ["Duality theorem","(A, B) controllable  equiv  (A^T, B^T) observable\n(A, C) observable  equiv  (A^T, C^T) controllable"],
        ["Transpose trick","To find L: solve K_dual = place(A^T, C^T, obs_poles)\nThen L = K_dual^T  -- exact mathematical equivalence"],
        ["Ackermann dual","L = phi_obs(A) * O^(-1) * e_1\nMirrors K = e_n^T * C_ctrl^(-1) * phi_ctrl(A)"],
        ["Bass-Gura dual","If A is in observable canonical form: L_i = alpha_i - a_i  (column vector)\nExact dual of Bass-Gura for state feedback"],
        ["LQR-Kalman duality","Kalman filter: solve A^T*P + P*A - P*C^T*R_v^(-1)*C*P + Q_w = 0 for P\nL = P*C^T*R_v^(-1)  --  exact dual of LQR Riccati equation"],
        ["MATLAB one-liner","L = place(A', C', obs_poles)'  (apostrophes do transpose)\nOr: L = (lqr(A', C', Q_w, R_v))'  for optimal (Kalman)"],
      ]}/>

      <h2 style={S.h2}>Ackermann's Formula for the Observer</h2>
      <p style={S.p}>
        Just as Ackermann's formula gives a closed-form expression for the state feedback gain K, its dual gives L for the observer. The formula uses the observability matrix and the desired observer characteristic polynomial evaluated at A. For hand calculation of low-order systems, this provides exact results in a systematic way.
      </p>
      <DiagramAckermannObserver/>
      <Table2 rows={[
        ["Formula","L = phi_obs(A) * O^(-1) * e_1\nphi_obs: desired obs char. poly at A; O: observability matrix; e_1=[1;0;...;0]"],
        ["phi_obs(A)","Desired char poly with obs poles substituted for s, then A substituted for s\nphi_obs(A) = A^n + b_(n-1)*A^(n-1) + ... + b_1*A + b_0*I"],
        ["Observability matrix O","O = [C; C*A; C*A^2; ...; C*A^(n-1)]  (nq x n)\nO^(-1) exists iff system is observable (rank = n)"],
        ["e_1 vs e_n^T","For L: use e_1 = [1;0;...;0] (first column selector)\nFor K: use e_n^T = [0;...;0;1]^T (last row selector)"],
        ["SISO only (practically)","Ackermann observer formula exact for q=1 (single output)\nFor MIMO observers, use place(A^T, C^T, poles)^T in MATLAB"],
        ["Numerical issues","Same ill-conditioning as K Ackermann for large n\nFor n > 5: always use place() or lqr() numerically"],
      ]}/>

      <h2 style={S.h2}>The Separation Principle</h2>
      <p style={S.p}>
        The separation principle is the theoretical cornerstone of observer-based control: it guarantees that the observer gain L and the state feedback gain K can be designed completely independently, as if the other did not exist. This remarkable result follows from the block upper-triangular structure of the augmented 2n-dimensional system matrix.
      </p>
      <DiagramSeparation/>
      <Table2 rows={[
        ["Separation principle","Combined system poles = eig(A-BK) union eig(A-LC)\nDesign K and L completely independently"],
        ["Block triangular proof","Augmented matrix [[A-BK, BK]; [0, A-LC]] is block upper triangular\nEigenvalues of upper triangular matrix = eigenvalues of diagonal blocks"],
        ["Design procedure","Step 1: design K as if full state available (ignore observer)\nStep 2: design L independently (ignore K) using duality"],
        ["Controller does not affect observer","Error e_dot = (A-LC)*e  -- no K appears in error equation\nController cannot destabilise a stable observer"],
        ["Observer does not affect CL poles","eig(A-BK) unchanged by adding observer\nPerformance specs achieved exactly as designed"],
        ["Separation fails for nonlinear systems","For nonlinear plants, error equation couples with state\nMust verify stability of combined nonlinear observer+controller"],
      ]}/>

      <h2 style={S.h2}>Step Response: Full-State vs Observer-Based</h2>
      <p style={S.p}>
        The practical question for any observer-based design is: how much does using x_hat instead of x degrade the closed-loop step response? The answer depends on how fast the observer poles are relative to the controller poles. With sufficiently fast observer poles, the response is essentially indistinguishable from ideal full-state feedback.
      </p>
      <DiagramResponseComparison/>
      <Table2 rows={[
        ["Ideal (full-state)","Controller uses exact x: u = -K*x\nAchieves designed performance exactly"],
        ["Observer-based (fast L)","Observer error converges before step response dominates\nResponse almost identical to full-state -- recommended design"],
        ["Observer-based (medium L)","Small initial error phase visible\nSteady state and settling time still meet specs"],
        ["Observer-based (slow L)","Observer error is significant during transient\nController uses poor estimate -- degraded initial performance"],
        ["Steady-state equivalence","For any stable observer, x_hat -> x as t -> inf\nSteady-state response is always identical to full-state design"],
        ["Initial conditions","Observer error at t=0 depends on initial estimate x_hat(0)\nIf x_hat(0) = x(0): no observer transient; if x_hat(0) = 0: initial error = x(0)"],
      ]}/>

      <h2 style={S.h2}>Luenberger vs Kalman Filter</h2>
      <p style={S.p}>
        The Luenberger observer and the Kalman filter share the same structure but differ in how L is chosen. Luenberger uses pole placement -- the designer specifies where the eigenvalues of A-LC should go. The Kalman filter solves an optimisation problem to minimise the estimation error covariance given statistical models of process and measurement noise. Both are valid; the choice depends on how well the noise characteristics are known.
      </p>
      <DiagramKalmanComparison/>
      <Table2 rows={[
        ["Same structure","Both: x_hat_dot = A*x_hat + B*u + L*(y - C*x_hat)\nOnly difference: how L is computed"],
        ["Luenberger approach","L chosen via pole placement: place eig(A-LC) at desired locations\nSimple, deterministic, does not require noise models"],
        ["Kalman filter approach","L_k = P*C^T*R_v^(-1) minimises E[||x-x_hat||^2]\nRequires knowledge of Q_w (process noise) and R_v (measurement noise)"],
        ["Kalman Riccati equation","A*P + P*A^T - P*C^T*R_v^(-1)*C*P + Q_w = 0\nSolve for P (steady-state Kalman gain pre-computed offline)"],
        ["LQG controller","LQR (optimal K) + Kalman filter (optimal L) = LQG\nMATLAB: kalman() or design separately and combine"],
        ["When to use Kalman","When Q_w and R_v can be estimated from data\nSignificant sensor noise; stochastic disturbances present"],
      ]}/>

      <h2 style={S.h2}>Output Feedback Transfer Function</h2>
      <p style={S.p}>
        The combination of observer and state feedback creates a dynamic output feedback controller -- a system that processes the measured output y and produces the control input u, without any direct access to the states. This controller has its own dynamics (order n), making the total closed-loop system order 2n.
      </p>
      <DiagramOutputFeedback/>
      <Table2 rows={[
        ["Output feedback controller","C(s) = K*(sI - A + BK + LC)^(-1)*L\nMaps y(s) to u(s); has order n"],
        ["Closed-loop with plant","Closed-loop TF: G_cl(s) = G(s)*C(s) / (1 + G(s)*C(s))\nEquivalent to standard output feedback analysis"],
        ["Poles of C(s)","Eigenvalues of A - BK - LC (NOT same as A-BK or A-LC separately)\nThese are the poles of the dynamic controller itself"],
        ["Total system order","Plant order n + observer order n = 2n total\nFor 2nd-order plant: 4th-order closed-loop system"],
        ["LQG (LQR + Kalman)","Optimal output feedback for LTI systems with Gaussian noise\nK from lqr(A,B,Q,R) + L from kalman(A,C,Q_w,R_v)"],
        ["Loop transfer recovery","Systematic technique to recover LQR margins in LQG design\nAs R_v -> 0: LTR recovers LQR loop properties at plant input"],
      ]}/>

      <h2 style={S.h2}>Reduced-Order Observer</h2>
      <p style={S.p}>
        When q of the n states are directly measured through the output equation y = Cx, there is no need to estimate those states -- they are already known. The reduced-order observer estimates only the remaining n-q unmeasured states, resulting in a simpler observer of order n-q with fewer poles to place and less noise amplification.
      </p>
      <DiagramReducedOrder/>
      <Table2 rows={[
        ["Motivation","If q outputs are measured, q states are known: no need to re-estimate them\nFull-order observer redundantly estimates known states"],
        ["Partition","x = [x_a; x_b] where x_a is measured (via y=x_a) and x_b is unknown\nA, B partitioned accordingly"],
        ["Reduced observer order","Full observer: order n.  Reduced observer: order n-q\nFor single-output system: order n-1 (saves one integrator)"],
        ["Reduced gain L_r","L_r is (n-q) x q (fewer rows than full L)\nDesign: place eig(A_bb - L_r*A_ab) at desired locations"],
        ["Trade-off vs full-order","Reduced: simpler, less noise, fewer poles to place\nFull: easier to design, standard algorithms apply directly"],
        ["Implementation","Transform to observable coordinates first\nUse MATLAB obsv() to check and then solve dual pole placement"],
      ]}/>

      <h2 style={S.h2}>Complete Observer Design Workflow</h2>
      <Table2 rows={[
        ["Step 1: Check observability","rank(obsv(A,C)) == n ?  If not: cannot build full observer\nIdentify which modes are unobservable; use reduced observer if q > 0"],
        ["Step 2: Design K first","Design state feedback K ignoring observer (separation principle)\nPlace eig(A-BK) to meet %OS, ts specs"],
        ["Step 3: Choose observer speed","sigma_obs = (2 to 5) * sigma_cl (dominant CL pole sigma)\nFor initial design: use sigma_obs = 3 * sigma_cl"],
        ["Step 4: Compute L","L = place(A^T, C^T, obs_poles)^T  (MATLAB, transpose trick)\nOr: L = (lqr(A^T, C^T, Q_w, R_v))^T for optimal (Kalman)"],
        ["Step 5: Verify combined","Compute eig(A-BK) and eig(A-LC) separately\nAll eigenvalues must be in LHP; check 2n total poles"],
        ["Step 6: Simulate","Simulate with x_hat(0) != x(0) to test observer convergence\nCheck observer transient vs control performance specs"],
        ["Step 7: Noise test","If measurement noise present: increase L cautiously or use Kalman\nPlot x_hat with noise; check if control input u becomes noisy"],
      ]}/>

      <InfoBox title="Key Formulae Summary" items={[
        "Observer equation:  x_hat_dot = A*x_hat + B*u + L*(y - C*x_hat)",
        "Error dynamics:  e_dot = (A - L*C)*e   --   stable if all eig(A-LC) have Re(s) &lt; 0",
        "Duality / MATLAB:  L = place(A^T, C^T, obs_poles)^T",
        "Ackermann dual:  L = phi_obs(A) * O^(-1) * e_1   (e_1 = first basis vector)",
        "Separation:  combined poles = eig(A-BK) union eig(A-LC)",
        "Speed rule:  place obs. poles at 2 to 5 times faster sigma than CL poles",
        "Output feedback TF:  C(s) = K*(sI - A + BK + LC)^(-1)*L",
        "Kalman gain:  L = P*C^T*R_v^(-1)   where A*P + P*A^T - P*C^T*R_v^(-1)*C*P + Q_w = 0",
        "MATLAB Kalman:  L = (lqr(A^T, C^T, Q_w, R_v))^T   (using duality)",
      ]}/>
    </div>
  );
}